/**
 * @Author : ShaJiaJing
 * @Date : 2019/6/5
 * @Version : 1.0
 * @Content : 消息接口
 */
import fetch from '@/utils/fetch2'

/**
 * 获取消息列表
 * @param page  "页码" 必传
 * @param size  "每页大小" 必传
 * @param alermDesc  "告警内容"
 * @param alertStatus  "告警状态" new:未确认   confirmed：已确认
 * @param date  "告警时间" 1：今天，2：昨天，3：最近7天，4：最近30天
 * @returns {*}
 */
export function getMessageList (params) {
  return fetch.get('/alarms', params)
}

/**
 * 修改消息列表状态
 * @param alertStatus "告警状态" new:未确认   confirmed：已确认
 * @param ids "修改的id，逗号分隔， 全部修改时不传"
 * @param data: json字符串
 * @returns {AxiosPromise<any> | * | IDBRequest<IDBValidKey> | Promise<void>}
 */
export function editMessageList (data) {
  return fetch.put('/alarms', JSON.stringify(data))
}

/**
 * 删除信息
 * @param ids ”“”array “"删除的id"
 * @returns {*}
 */
export function delMessage (ids) {
  ids = ids.join(',')
  return fetch.delete('/alarms/clear', { ids })
}
